import { Box } from "@mui/system";
import { Typography } from "@mui/material";
import ConversionsUploadFilter from "./ConversionsUploadFilter";

const ConversionsUpload = () => {
  return (
    <>
      <Box sx={{ px: 2 }}>
        <ConversionsUploadFilter />
        <Typography align="center" py={4}> Coming form "Biz Leader / Dashboard / Conversions Tab"</Typography>
      </Box>
    </>
  );
};

export default ConversionsUpload;
